import { render, staticRenderFns } from "./QuestionHeading.vue?vue&type=template&id=ea703744&scoped=true&"
import script from "./QuestionHeading.vue?vue&type=script&lang=js&"
export * from "./QuestionHeading.vue?vue&type=script&lang=js&"
import style0 from "./QuestionHeading.vue?vue&type=style&index=0&id=ea703744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea703744",
  null
  
)

export default component.exports